export function validateFlagMessage(raw: string): string | null {
  const message = raw.trim();
  return message.length === 0 ? null : message;
}
